<h2 matDialogTitle>Submit Confirmation</h2>
<div matDialog-content>
    <p>{{data.message}}</p>
</div>
<div matDialogActions>
    <!-- <button mat-raised-button color="primary" (click)="confirm()">Yes</button>
    <button mat-raised-button color="primary" (click)="closeDialog()">Cancel</button> -->
    <button mat-raised-button color="primary" (click)="confirm()">Yes</button>
    <button mat-raised-button color="primary" (click)="closeDialog()">Cancel</button>
</div>
